import { getVariantAttributesByProductId } from '@vp/upload-and-print-validator/dist/clients/merchandisingSiteExperienceClient';
import { VariantAttribute } from '@vp/upload-and-print-validator';
import { getAuthHeader } from 'src/utils/authHeaderUtil';
import { experienceType, REQUESTOR } from 'src/utils/Constants';
import { currentCulture } from 'src/utils/cultureUtil';

const optionNamesCache: { [key: string]: VariantAttribute[] } = {};

async function getProductOptionsFromServer(productKey: string, productVersion: number): Promise<VariantAttribute[]> {
  const productPageResult = await getVariantAttributesByProductId(
    {
      productId: productKey,
      version: productVersion,
      culture: currentCulture.toLowerCase(),
      tenant: REQUESTOR,
      experienceType: experienceType.productPage,
    },
    getAuthHeader()
  ).catch(err => {
    throw new Error(`Invalid response from MSX getting PDC product options: ${err.message}`);
  });

  const pdcResult = await getVariantAttributesByProductId(
    {
      productId: productKey,
      version: productVersion,
      culture: currentCulture.toLowerCase(),
      tenant: REQUESTOR,
      experienceType: experienceType.pdcPage,
    },
    getAuthHeader()
  ).catch(err => {
    throw new Error(`Invalid response from MSX getting PDC product options: ${err.message}`);
  });

  return productPageResult?.filter(
    productPageOption => !pdcResult?.find(pdcOption => pdcOption.key.key === productPageOption.key.key)
  );
}

export async function getProductOptions(productKey: string, productVersion: number): Promise<VariantAttribute[]> {
  const keyVersionPair = `${productKey}-${productVersion}`;
  return (optionNamesCache[keyVersionPair] =
    optionNamesCache[keyVersionPair] || (await getProductOptionsFromServer(productKey, productVersion)));
}
